<template>
	<div>
		<b-row>
			<b-col lg="3">
				<vs-card>
					<vs-chip v-if="inventoryCountingItem.StockTakingDone" color="success">
						<Icon icon="lets-icons:done-duotone" width="20" height="20" />
					</vs-chip>
					<vs-chip v-else color="danger">
						<Icon icon="carbon:incomplete-cancel" width="20" height="20" />
					</vs-chip>
					<h3 class="text-primary">{{ inventoryCountingItem.StockTakingCode }}</h3>
					<h6 class="text-primary">{{ inventoryCountingItem.CompanyName }}</h6>
					<h6 class="text-primary">{{ inventoryCountingItem.DepotName }}</h6>
					<vs-divider></vs-divider>
					<b-row style="margin-top: 15px; margin-bottom: 15px">
						<p class="mb-0">{{ $t("Quantity") }}</p>
						<vs-input size="small" v-model="selectedPerQty" type="text" class="w-full" name="value" id="value"
							:value="selectedPerQty" v-validate="'required'" />
					</b-row>
					<b-row style="margin-top: 15px; margin-bottom: 15px">
						<p class="mb-0">{{ $t("Barcode") }}</p>
						<vs-input size="small" v-model="itemCode" type="text" class="w-full" name="value" id="value"
							:value="itemCode" @keyup.enter="getProduct" />
					</b-row>
					<b-row>
						<div style="height: 95%">
							<input id="itemCode" ref="itemCode" v-model="itemCode" @keyup.enter="getProduct" @focus="handleFocus(1)"
								@input="stockNoValidate" autocomplete="off" style="
                  padding: 0px;
                  margin: 0px;
                  width: 50px;
                  position: absolute;
                  width: 250px;
                  height: 200px;
                  opacity: 0;
                " />
							<b-row style="text-align: center">
								<b-col>
									<Icon icon="bi:upc-scan" style="margin-right: 5px" width="150" height="150" />
								</b-col>
								<h4 style="text-align: center" class="mt-10">
									{{ $t(scanText) }}
								</h4>
							</b-row>
						</div>
					</b-row>
				</vs-card>
			</b-col>
			<b-col>
				<vs-card>
					<component :is="scrollbarTag" ref="scroll" class="vs-input--label scroll-area--data-list-add-new"
						:settings="settings" :key="$vs.rtl">
						<template lang="html">
							<vs-table v-model="selected" @selected="handleSelected" :data="countingList">
								<template slot="thead">
									<vs-th sort-key="ReadBarcode">{{ $t("ReadBarcode") }} </vs-th>
									<vs-th sort-key="ReadBarcodeQuantity">{{
										$t("ReadBarcodeQuantity")
									}}</vs-th>
									<vs-th sort-key="DepotBarcodeQuantity">{{
										$t("DepotBarcodeQuantity")
									}}</vs-th>

									<vs-th sort-key="actions">{{ $t("Actions") }}</vs-th>
								</template>
								<template slot-scope="{ data }">
									<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
										<vs-td :data="data[indextr].ReadBarcode">
											{{ data[indextr].ReadBarcode }}
										</vs-td>

										<vs-td :data="data[indextr].ReadBarcodeQuantity">
											<vs-chip color="success" style="font-size: large; font-weight: 700">
												{{ data[indextr].ReadBarcodeQuantity }}
											</vs-chip>
										</vs-td>
										<vs-td :data="data[indextr].DepotBarcodeQuantity">
											<vs-chip color="success" style="font-size: large; font-weight: 700">
												{{ data[indextr].DepotBarcodeQuantity }}
											</vs-chip>
										</vs-td>
										<vs-td>
											<b-row>
												<b-button class="bg-primary" style="border-color: white" size="sm" v-on:click="
													isSidebarActiveCountingAgain = true;
												againParam = tr;
												">
													{{ $t("Again") }}
												</b-button>
											</b-row>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</template>
					</component>
					<div class="items-center pl-6 mt-5 mb-0">
						<b-row align-h="end">
							<b-col cols="3" md="auto">
								<b-button class="bg-warning" style="border-color: white"
									v-on:click="excelStock('InvertoryTakingList', countingList)">
									<Icon icon="icon-park-outline:excel" style="margin-right: 5px" width="20" height="20" />{{ $t("Excel")
									}}
								</b-button>
							</b-col>
							<b-col cols="3" md="auto" style="padding: 0px">
								<b-button class="bg-danger" style="border-color: white"
									v-on:click="isSidebarActiveProcesscancelShelfList = true">
									<Icon icon="material-symbols:cancel-outline" style="margin-right: 5px" width="20" height="20" />{{
										$t("Cancel")
									}}
								</b-button>
							</b-col>
							<b-col cols="3" md="auto" v-if="!isDoneControl">
								<b-button class="bg-primary" style="border-color: white"
									v-on:click="isSidebarActiveCountingDone = true">
									<Icon icon="material-symbols:save-outline" style="margin-right: 5px" width="20" height="20" />{{
										$t("Save") }}
								</b-button>
							</b-col>

						</b-row>
					</div>
				</vs-card>
			</b-col>
		</b-row>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="againQuantity"
			:active.sync="isSidebarActiveCountingAgain" color="warning">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
		<vs-prompt :title="$t('Warning')" :acceptText="$t('Submit')" :cancelText="$t('Cancel')" @accept="saveAllList"
			:active.sync="isSidebarActiveCountingDone" color="warning">
			<div style="text-align: center" class="con-exemple-prompt">
				<span>
					<b-row style="margin-top: 15px">
						<b-col cols="12" align-self="center">
							<h6>{{ $t("DoConfirm") }}</h6>
						</b-col>
					</b-row>
				</span>
			</div>
		</vs-prompt>
	</div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
export default {
	components: {
		Icon,
		VuePerfectScrollbar,
		vSelect,
	},
	data() {
		return {
			isDoneControl: true,
			selectedPerQty: 1,
			perQty: [1, 10, 50, 100, 200, 300, 500, 1000],
			againParam: "",
			isSidebarActiveCountingAgain: false,
			isSidebarActiveCountingDone: false,
			selected: "",
			scanText: "",
			itemCode: "",
			currentFocusedInput: null,
			firstInputFocused: false,
			inventoryCountingItem: [],
			countingList: [],
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	methods: {
		excelStock(baslik, dataLc) {
			const data = dataLc;

			const worksheet = XLSX.utils.json_to_sheet(data);

			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

			const excelBuffer = XLSX.write(workbook, {
				bookType: "xlsx",
				type: "array",
			});

			// Excel dosyasını kaydetme
			const blob = new Blob([excelBuffer], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			let today = this.parseDate(new Date());

			saveAs(blob, baslik + today + ".xlsx");
		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		stockNoValidate() {
			this.itemCode = this.itemCode.replace(/\?/g, "_").replace(/ı/g, "i");
		},
		againQuantity() {
			const vs = this.$vs;
			this.$store.dispatch("stock/againStockTaking", this.againParam).then((response) => {
				if (response.success == true) {
					this.getStockTakingList();
					vs.notify({
						text: "Başarılı",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "success",
						position: "top-center",
					});
				} else {
					console.log(response.statusText);
					vs.notify({
						text: response.message,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				}
			});
		},
		saveAllList() {
			const vs = this.$vs;
			this.$store
				.dispatch("stock/doneStockTaking", this.countingList)
				.then((response) => {
					if (response.success == true) {
						this.isDoneControl = true
						this.getStockTakingList();
						this.$router
							.push("/inventory-counting")
							.catch(() => { });
						vs.notify({
							text: "Başarılı",
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
					} else {
						console.log(response.statusText);
						vs.notify({
							text: response.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				});
		},
		handleSelected(tr) { },
		getStockTakingList() {
			this.$store
				.dispatch(
					"stock/listStockTakingItemForId",
					this.inventoryCountingItem.StockTakingId
				)
				.then((response) => {
					if (response.success == true) {
						let respJson = JSON.parse(response.json);
						this.countingList = respJson;
					} else console.log(response.statusText);
				});
		},
		getProduct() {
			const vs = this.$vs;
			if (this.itemCode == "") {
				vs.notify({
					text: this.$("Validate"),
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "success",
					position: "top-center",
				});
			} else {
				let obj = {
					readBarcode: this.itemCode,
					readBarcodeQuantity: parseFloat(this.selectedPerQty),
					stockTakingId: this.inventoryCountingItem.StockTakingId,
				};
				this.$store.dispatch("stock/addStockTakingItem", obj).then((response) => {
					this.itemCode = "";
					if (response.success == true) {
						this.getStockTakingList();
						/*  vs.notify({
							text: response.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});*/
					} else {
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				});
			}
		},
		keepFocus() {
			/*  this.$nextTick(() => {
					if (this.currentFocusedInput === 1) {
						this.$refs.itemCode.focus();
					}
				});*/
		},
		handleFocus(inputNumber) {
			if (inputNumber === 1 && !this.firstInputFocused) {
				this.currentFocusedInput = 1;
				this.firstInputFocused = true;
			} else if (inputNumber === this.currentFocusedInput) {
				return;
			} else if (inputNumber !== 1) {
				this.currentFocusedInput = inputNumber;
			}
			this.keepFocus();
		},
	},
	mounted() {
		this.inventoryCountingItem = JSON.parse(this.$route.params.data);
		console.log(this.inventoryCountingItem.StockTakingDone)
		this.isDoneControl = this.inventoryCountingItem.StockTakingDone
		this.currentFocusedInput = 1;

		this.handleFocus(1);
		window.addEventListener("click", this.keepFocus);
		this.getStockTakingList();
	},

	beforeDestroy() {
		window.removeEventListener("click", this.keepFocus);
	},
	created() { },
	computed: {
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
};
</script>
<style lang="scss" scoped>
.scroll-area--data-list-add-new {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 210px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>
